import React from "react";

const FIELD_ERROR_STYLE: React.CSSProperties = {
    width: "100%",
    marginTop: "0.25rem",
    fontSize: "80%",
    color: "#f46a6a",
};

type FieldErrorProps = {
    children: React.ReactNode;
    /** When provided, fully replaces the default error style. */
    style?: React.CSSProperties;
};

/** Inline validation message shown under a form field. */
export function FieldError({ children, style }: FieldErrorProps) {
    return <div style={style ?? FIELD_ERROR_STYLE}>{children}</div>;
}
